import API from './utils/API';

export interface GetTokenResponse {
  data: {
    id: string;
    type: 'token';
    attributes: {
      expires_in: number;
      refresh_token: string;
      provider: string;
      user_id: string;
      scope: string;
      client_id: string;
    };
  };
}

class DiamAPI extends API {
  getToken = (username: string, password: string): Promise<GetTokenResponse> => {
    const req = this.fetchHelper.createNoTokenPostRequest(
      `${this.endpoint}/token`,
      {
        data: {
          type: 'token',
          attributes: {
            username,
            password,
            client_id: process.env.IAM_CLIENT,
          },
        },
      },
      false
    );

    return this.fetch(req);
  };

  refreshToken = (refreshToken: string): Promise<GetTokenResponse> => {
    const req = this.fetchHelper.createNoTokenPostRequest(
      `${this.endpoint}/token`,
      {
        data: {
          type: 'token',
          attributes: {
            refresh_token: refreshToken,
            client_id: process.env.IAM_CLIENT,
          },
        },
      },
      false
    );

    return this.fetch(req);
  };

  getUser = (userId: string, token: string, provider: string) => {
    const req = this.fetchHelper.createGetRequest(
      `${this.endpoint}/users/${userId}`,
      undefined,
      token,
      provider,
      false,
      true
    );
    return this.fetch(req);
  };

  invalidateToken = (token: string, provider: string) => {
    const req = this.fetchHelper.createDeleteRequest(
      `${this.endpoint}/token/${token}`,
      undefined,
      undefined,
      provider,
      false
    );
    return this.fetch(req);
  };

  registerUser = (user: any, locale: string) => {
    if (locale === undefined || locale === '') {
      locale = 'en-US';
    }

    const req = this.fetchHelper.createNoTokenPostRequest(
      `${this.endpoint}/users`,
      {
        data: {
          type: 'users',
          attributes: {
            username: user.email,
            password: user.password,
            language: user.language,
            country: user.country,
            first_name: user.firstname,
            last_name: user.lastname,
            custom_attributes: {
              fleet_locale: locale,
            },
          },
        },
      },
      false
    );

    return this.fetch(req);
  };

  updateUserLocale = (
    userId: string,
    locale: string,
    token: string,
    provider: string,
    oldCustomAttributes = {}
  ) => {
    const req = this.fetchHelper.createPatchRequest(
      `${this.endpoint}/users/${userId}`,
      {
        data: {
          type: 'users',
          attributes: {
            custom_attributes: {
              ...oldCustomAttributes,
              fleet_locale: locale,
            },
          },
        },
      },
      token,
      provider,
      false,
      true
    );

    return this.fetch(req);
  };
}

export default new DiamAPI(process.env.ENDPOINT_IAM || '');
